import React, { useContext } from 'react';
import styles from './Styles';
import ContentBox from '../../../common/ContentBox/ContentBox';
import { Select } from 'antd';
import { AppContext } from 'App.context';
import AppTextInput from 'Components/common/AppTextInput/AppTextInput';
import AppButton from 'Components/common/Forms/AppButton/AppButton';
import Icon, {
  CrownFilled,
  CrownTwoTone,
  DeleteOutlined,
  EditFilled,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeFilled,
  UserAddOutlined,
} from '@ant-design/icons';

export default function AddUserModal({ state, actions }) {
  const {
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);
  const { Option } = Select;

  return (
    <div style={{ paddingRight: '10%', paddingLeft: '10%' }}>
      <div style={styles.iconModal}>
        <UserAddOutlined />
      </div>
      <div style={styles.titleModal}>
        <p>{translate('team.newUserDetail.addNewUserToTeam')}</p>
      </div>
      <AppTextInput
        value={state.name}
        name={translate('team.newUserDetail.name')}
        onChange={value => actions.setField('name', value)}
      />
      <AppTextInput
        value={state.email}
        name={translate('team.newUserDetail.email')}
        onChange={value => actions.setField('email', value)}
      />
      <div style={{ marginBottom: '16px' }}>
        <label style={styles.labelTitle}>{translate('team.newUserDetail.hotel')}</label>
        <Select
          mode="multiple"
          allowClear
          style={{ width: '100%' }}
          value={state.hotel || []}
          onSelect={actions.onSelectNewHotel}
          onDeselect={actions.onDeselectNewHotel}
          onClear={actions.onClearNewHotel}
          optionFilterProp="children"
        >
          <Option value="all">{translate('hotelSelector.allHotels')}</Option>
          {state.hotels.map(hotel => (
            <Option key={hotel.id} value={hotel.id}>
              {hotel.name}
            </Option>
          ))}
        </Select>
      </div>
      <div style={{ marginBottom: '16px' }}>
        <label style={styles.labelTitle}>{translate('team.newUserDetail.permission')}</label>
        <Select
          value={state.role}
          onChange={value => actions.setField('role', value)}
          style={{ width: '100%' }}
        >
          <Option value="admin">
            <CrownFilled style={{ marginRight: '6px' }} />
            {translate('team.newUserDetail.permissions.admin')}
            <p style={styles.descriptionText}>
              {translate('team.newUserDetail.permissions.adminDescription')}
            </p>
          </Option>
          <Option value="user">
            <EditFilled style={{ marginRight: '6px' }} />
            {translate('team.newUserDetail.permissions.user')}
            <p style={styles.descriptionText}>
              {translate('team.newUserDetail.permissions.userDescription')}
            </p>
          </Option>
          <Option value="guest">
            <EyeFilled style={{ marginRight: '6px' }} />
            {translate('team.newUserDetail.permissions.guest')}
            <p style={styles.descriptionText}>
              {translate('team.newUserDetail.permissions.guestDescription')}
            </p>
          </Option>
        </Select>
      </div>
      <div></div>
      <div style={{ paddingLeft: 60 }}>
        <AppButton
          text={translate('team.newUserDetail.invite')}
          action={() => actions.validateFieldsAndSend()}
          style={{ width: '80%' }}
        />
      </div>
    </div>
  );
}
